import React from 'react'
import {
  RouteObject,
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom'

import { authenticatedRoutes } from './authenticatedRoutes'
import { publicRoutes } from './publicRoutes'
import { exceptionRoutes } from './exceptionRoutes'

import { AppProviders } from 'views/AppProviders'

export const Router = () => {
  const routes: RouteObject[] = [
    {
      element: <AppProviders />,
      children: [authenticatedRoutes(), publicRoutes, exceptionRoutes],
    },
  ]

  return <RouterProvider router={createBrowserRouter(routes)} />
}
